'use client';
import { Link } from '@/components/Link';
import { Typography } from '@/components/Typography';
import { JucyLogo } from '@/components/icons/JucyLogo';

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return (
        <main className="flex min-h-screen flex-col items-center justify-between py-16">
            <div className="flex shrink-0 items-center px-4">
                <Link href="/" className="max-w-70 text-secondary block mb-8" aria-label="Go to homepage">
                    <JucyLogo width="100%" />
                </Link>
            </div>
            <div className="w-full max-w-150 px-4">
                <div className="text-center flex items-center flex-col">
                    <Typography as="h1" variant="h1" className="text-size-h2 md:text-size-h1 leading-tight md:leading-tight">
                        Whoops, something went wrong on our end
                    </Typography>
                    <Typography variant="paragraph-heavy">Error 500</Typography>
                    {error.message ? (
                        <Typography variant="paragraph">
                            {error.message}
                            {error.digest ? (
                                <>
                                    <br />
                                    Digest: {error.digest}
                                </>
                            ) : null}
                        </Typography>
                    ) : null}

                    <div className="mt-14 text-pretty text-lg font-medium leading-relaxed sm:text-xl sm:leading-8">Please try again later, or return to the homepage.</div>
                    {process.env.NODE_ENV === 'development' ? <pre className="text-left">{JSON.stringify(error, null, 2)}</pre> : null}

                    <div className="mt-24 mb-8 flex items-center justify-center gap-4  flex-wrap">
                        <button className="btn btn-primary py-6 lg:px-8" onClick={() => reset()}>
                            Try Again
                        </button>
                        <Link href="/" className="btn btn-primary py-6 lg:px-8">
                            Go back home
                        </Link>
                    </div>
                </div>
            </div>
            <div className="flex shrink-0 items-center px-4 text-sm text-slate-700">&copy; {new Date().getFullYear()} Travvia</div>
        </main>
    );
}
